import { useAtomValue, useSetAtom } from 'jotai'
import { useEffect } from 'react'
import {
    availableLanguagesAtom,
    selectedLanguageAtom,
    currentLanguageAtom,
    changeLanguageAtom,
    setLanguagesFromCountryAtom,
    restoreLanguageAtom
} from '../store/language.store'

export const useLanguage = () => {
    const availableLanguages = useAtomValue(availableLanguagesAtom)
    const selectedLanguage = useAtomValue(selectedLanguageAtom)
    const currentLanguage = useAtomValue(currentLanguageAtom)
    const changeLanguage = useSetAtom(changeLanguageAtom)
    const setLanguagesFromCountry = useSetAtom(setLanguagesFromCountryAtom)
    const restoreLanguage = useSetAtom(restoreLanguageAtom)

    // Note: languageState from @repo/unicity is managed by useGlicDictionary hook
    // Do NOT sync selectedLanguageAtom with languageState here to avoid conflicts

    // Restore language from localStorage on mount
    useEffect(() => {
        if (availableLanguages.length > 0) {
            restoreLanguage()
        }
    }, [availableLanguages, restoreLanguage])

    return {
        // State
        availableLanguages,
        selectedLanguage,
        currentLanguage,

        // Actions
        changeLanguage,
        setLanguagesFromCountry,

        // Helpers
        hasMultipleLanguages: availableLanguages.length > 1,
        isLanguageSet: selectedLanguage !== ''
    }
}
